function h(a, i, d) {
  let l = !1, o = !1, F = 1, B = i;
  if (i === 1)
    return {
      hasFastBackward: !1,
      hasFastForward: !1,
      fastForwardTo: B,
      fastBackwardTo: F,
      items: [
        {
          type: "page",
          label: 1,
          active: a === 1,
          mayBeFastBackward: !1,
          mayBeFastForward: !1
        }
      ]
    };
  if (i === 2)
    return {
      hasFastBackward: !1,
      hasFastForward: !1,
      fastForwardTo: B,
      fastBackwardTo: F,
      items: [
        {
          type: "page",
          label: 1,
          active: a === 1,
          mayBeFastBackward: !1,
          mayBeFastForward: !1
        },
        {
          type: "page",
          label: 2,
          active: a === 2,
          mayBeFastBackward: !0,
          mayBeFastForward: !1
        }
      ]
    };
  const f = 1, e = i;
  let r = a, s = a;
  const p = (d - 5) / 2;
  s += Math.ceil(p), s = Math.min(Math.max(s, f + d - 3), e - 2), r -= Math.floor(p), r = Math.max(Math.min(r, e - d + 3), f + 2);
  let w = !1, y = !1;
  r > f + 2 && (w = !0), s < e - 2 && (y = !0);
  const t = [];
  t.push({
    type: "page",
    label: 1,
    active: a === 1,
    mayBeFastBackward: !1,
    mayBeFastForward: !1
  }), w ? (l = !0, F = r - 1, t.push({
    type: "fast-backward",
    active: !1,
    label: void 0,
    options: c(f + 1, r - 1)
  })) : e >= f + 1 && t.push({
    type: "page",
    label: f + 1,
    mayBeFastBackward: !0,
    mayBeFastForward: !1,
    active: a === f + 1
  });
  for (let m = r; m <= s; ++m)
    t.push({
      type: "page",
      label: m,
      mayBeFastBackward: !1,
      mayBeFastForward: !1,
      active: a === m
    });
  return y ? (o = !0, B = s + 1, t.push({
    type: "fast-forward",
    active: !1,
    label: void 0,
    options: c(s + 1, e - 1)
  })) : s === e - 2 && t[t.length - 1].label !== e - 1 && t.push({
    type: "page",
    mayBeFastForward: !0,
    mayBeFastBackward: !1,
    label: e - 1,
    active: a === e - 1
  }), t[t.length - 1].label !== e && t.push({
    type: "page",
    mayBeFastForward: !1,
    mayBeFastBackward: !1,
    label: e,
    active: a === e
  }), {
    hasFastBackward: l,
    hasFastForward: o,
    fastBackwardTo: F,
    fastForwardTo: B,
    items: t
  };
}
function c(a, i) {
  const d = [];
  for (let l = a; l <= i; ++l)
    d.push({
      label: `${l}`,
      value: l
    });
  return d;
}
export {
  h as createPageItemsInfo
};
